import { Divider, Stack, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";

import { FailedHeaderIcon, Header } from "components";
import { formatDate } from "utils";

export const ConfirmationFailedPayment = ({
  paymentDeadline,
}: {
  paymentDeadline?: string;
}) => {
  const { t } = useTranslation();

  return (
    <Stack sx={{ gap: 2 }}>
      <Header
        title={t("payment.failed.title")}
        subtitle={t("payment.failed.subtitle")}
        icon={<FailedHeaderIcon />}
      />
      <Typography>{t("payment.failed.retryInfo")}</Typography>
      <Typography>{t("payment.failed.bankInfo")}</Typography>
      <Typography>
        <Trans
          i18nKey="payment.deadline"
          values={{ date: formatDate(paymentDeadline) }}
          components={{ bold: <strong /> }}
        />
      </Typography>
      <Typography>{t("confirmation.confirmationEmailSent")}</Typography>
      <Typography>
        <Trans
          i18nKey="confirmation.examScheduleNotice"
          components={{ bold: <strong /> }}
        />
      </Typography>
      <Typography>{t("confirmation.oralExamNote")}</Typography>
      <Divider />
      <Typography>{t("confirmation.thankYou")}</Typography>
    </Stack>
  );
};
